<div class="basin-pb-4 basin-width-100">
    <p class="basin-mb-2 note-text">
        Note: Once confirmed, users will continue to have uninterrupted access to their data. Please ensure payment has
        been collected before proceeding as these changes cannot be undone.
    </p>
    <form [formGroup]="form" class="form-container basin-display-flex basin-gap-2">
        <formly-form [form]="form" [fields]="renewStudyAreaFields" [model]="model" [options]="options"></formly-form>
    </form>
</div>

<div class="basin-display-flex basin-justify-content-end basin-width-100">
    <button pButton type="button" (click)="onCancel()" class="p-button-text basin-mr-6">
        Cancel
    </button>

    <button pButton type="submit" (click)="onSave()" class="p-button-text" [disabled]="form.invalid">
        Save
    </button>
</div>